import { map } from "@gordonb/generator";
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import {
  type ForceNote,
  toUncertainty,
} from "../../../../models/note/force.ts";
import {
  toColor as toCategoryColor,
  forceCategoryStyles,
} from "../../../../models/force-category.ts";
import * as Styles from "../../../styles.ts";
import * as Scatterplot from "../scatter-plot.ts";
import "../scatter-plot.ts";
import { type Slug } from "../../../../models/slug.ts";
import { customEvent } from "../../../util/event.ts";
import { jitter } from "../../../../util/jitter.ts";

export const forcesToScatterplotDatapoints = (
  forces: Iterable<ForceNote>,
): Scatterplot.Datapoint[] => {
  return Array.from(
    map(forces, (force) => {
      return {
        id: force.slug,
        x: toUncertainty(force.meta.certainty) + jitter(`${force.slug}:x`),
        y: force.meta.impact + jitter(`${force.slug}:y`),
        title: force.title,
        color: toCategoryColor(force.meta.category),
        // TODO: bring back links
        links: [],
      };
    }),
  );
};

const styles = css`
  :host {
    display: block;
    height: 100cqh;
    width: 100cqw;
    container-type: size;
  }
`;

export const activateForceEvent = customEvent<Slug>("activate-force", {
  bubbles: true,
  composed: true,
});

@customElement("force-map-panel")
export class ForceVisPanel extends LitElement {
  static override styles = [Styles.base, forceCategoryStyles, styles];

  @property({ type: String })
  accessor heading = "Force Map";

  @property({ type: Array })
  accessor forces: Map<Slug, ForceNote> = new Map();

  #onActivateDatapoint = (
    event: Scatterplot.ActivateScatterplotDatapointEvent,
  ) => {
    this.dispatchEvent(activateForceEvent(event.detail.id));
  };

  override render() {
    const scatterplot = Scatterplot.model({
      datapoints: forcesToScatterplotDatapoints(this.forces.values()),
      xAxisLabel: "Uncertainty",
      yAxisLabel: "Impact",
    });

    return html`
      <scatter-plot
        @activate-scatterplot-datapoint="${this.#onActivateDatapoint}"
        .state="${scatterplot}"
      ></scatter-plot>
    `;
  }
}
